import { render, staticRenderFns } from "./BrbVideo.vue?vue&type=template&id=37c49e2e&"
import script from "./BrbVideo.vue?vue&type=script&lang=js&"
export * from "./BrbVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c49e2e')) {
      api.createRecord('37c49e2e', component.options)
    } else {
      api.reload('37c49e2e', component.options)
    }
    module.hot.accept("./BrbVideo.vue?vue&type=template&id=37c49e2e&", function () {
      api.rerender('37c49e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/components/BrbVideo.vue"
export default component.exports